import api from "./api";

export const money = (n, currency = "₺") =>
  `${Number(n || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;

export const currencySymbol = (code) => ({ TRY: "₺", USD: "$", EUR: "€", GBP: "£" }[code || "USD"]);
export const currencyLabel = (code) => code === "TRY" ? "TL" : (code || "USD");
export const snapshotRates = (quote) => ({
  TRY: 1,
  USD: Number(quote.usd_rate || ((quote.currency || "USD") === "USD" ? quote.currency_rate : 0)),
  EUR: Number(quote.currency === "EUR" ? quote.currency_rate : quote.eur_rate),
  GBP: Number(quote.currency === "GBP" ? quote.currency_rate : quote.gbp_rate),
});

export const emptyItem = () => ({ product_name: "", sku: "", quantity: 1, list_price: 0, discount: 0, image_url: "" });

export const defaultCompany = {
  company_name: "CDS Teknoloji", address: "", phone: "", email: "", website: "",
  tax_number: "", tax_office: "", bank_details: "", logo_url: "", signature_url: "",
  primary_color: "#2563eb",
  ref_prefix: "KNX", references_text: "", references: [], partners_text: "", partners: [],
  rate_margin: 0.4, rate_rounding: "0.1",
  admin_notification_email: "", notify_on_approval: true, reminder_from_name: "",
  email_provider: "managed", resend_api_key: "", resend_from_email: "",
  smtp_host: "", smtp_port: 587, smtp_secure: "starttls",
  smtp_username: "", smtp_password: "", smtp_from_email: "",
  email_tpl_approval_subject: "", email_tpl_approval_body: "",
  email_tpl_reminder_subject: "", email_tpl_reminder_body: "",
  email_tpl_notify_subject: "", email_tpl_notify_body: "",
  payment_provider: "none", payment_manual_url: "",
  iyzico_env: "sandbox", iyzico_api_key: "", iyzico_secret_key: "",
  paytr_merchant_id: "", paytr_merchant_key: "", paytr_merchant_salt: "", paytr_test_mode: true,
  odeal_env: "stage", odeal_client_id: "", odeal_client_secret: "",
};

export const emptyQuote = () => ({
  customer_id: "", customer_name: "", customer_phone: "", customer_email: "",
  customer_location: "", customer_tax_office: "", customer_tax_number: "", customer_contact: "",
  subject: "", vat_rate: 20, delivery_terms: "", payment_terms: "", validity_days: 1,
  notes: "Fiyatlar nakit fiyatıdır.", items: [emptyItem()], show_images: false,
  status: "taslak", follow_up_date: null, rate_mode: "manual",
  currency: "USD", usd_rate: 0, eur_rate: 0, gbp_rate: 0,
});

export const THEME_PRESETS = [
  { name: "Kobalt", value: "#2563eb" }, { name: "Zümrüt", value: "#059669" },
  { name: "Erguvan", value: "#7c3aed" }, { name: "Amber", value: "#d97706" },
  { name: "Kırmızı Toprak", value: "#b91c1c" }, { name: "Teal", value: "#0d9488" },
  { name: "İndigo", value: "#4338ca" }, { name: "Grafit", value: "#334155" },
];

export const STATUS = [
  { value: "taslak", label: "Taslak", color: "#94a3b8" },
  { value: "gonderildi", label: "Gönderildi", color: "#3b82f6" },
  { value: "gorusuluyor", label: "Görüşülüyor", color: "#f59e0b" },
  { value: "onaylandi", label: "Onaylandı", color: "#059669" },
  { value: "reddedildi", label: "Reddedildi", color: "#dc2626" },
  { value: "beklemede", label: "Beklemede", color: "#d97706" },
];

export const backendUrl = (path) =>
  path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : "";

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/uploads", form, { headers: { "Content-Type": "multipart/form-data" } });
  return { ...data, absoluteUrl: backendUrl(data.url) };
}
